import React from "react";
import AsiaPayoutOrchestrator from "../../shared/AsiaPayoutOrchestrator";
import { chinaConfig } from "./config";

const ChinaPayout: React.FC = () => {
  return <AsiaPayoutOrchestrator config={chinaConfig} />;
};

export default ChinaPayout;
